import { OpenTrigger } from "../../enums/open-trigger.enum";
import { PostMessageEvent } from "../../enums/post-message-event.enum";
import { QuizMode } from "../../enums/quiz-mode.enum";
import { QuizStatus } from "../../enums/quiz-status.enum";
import { SceneToken } from "../../enums/scene-token.enum";
import { IModule } from "../../interfaces/module.interface";
import { IPostMessageProvider } from "../../interfaces/post-message-provider.interface";
import { IQuiz } from "../../interfaces/quiz.interface";
import { HistoryProvider } from "./history.provider";
import { IHistoryProvider } from "./interfaces/history-provider.interface";
import { Stack } from "./stack";

export default class BrowserHistory implements IModule {
  constructor(private readonly postMessageProvider: IPostMessageProvider) {
    this.historyProvider = new HistoryProvider(new Stack());
  }

  private readonly historyProvider: IHistoryProvider;
  private quiz: IQuiz;

  public readonly name = "browser-history";

  public async getData() {
    return this.historyProvider.stack
  }

  public init(quiz: IQuiz) {
    this.quiz = quiz;
    this.historyProvider.onpopstate(event => this.onHistoryChange(event));
    this.postMessageProvider.subscribe(PostMessageEvent.CHANGE_HISTORY, (message) => this.onQuizChangeHistory(message.data));

    this.quiz.beforeOpen((trigger, page) => {
      if (trigger == OpenTrigger.QUIZ_MODE_FULL) {
        this.historyProvider.replace({ token: SceneToken.START_PAGE });
        return true;
      }

      if (trigger != OpenTrigger.HISTORY_API) {
        if (this.historyProvider.stack.forwardState?.namespace == "dentolo_quiz") {
          this.historyProvider.forward();
          return false;
        } else if (this.historyProvider.stack.previousState?.namespace == "dentolo_quiz") {
          this.historyProvider.back();
          return false;
        }
        if (this.quiz.getState().quizOptions.mode == QuizMode.POPUP && !this.quiz.getState().wasOpened) {
          this.historyProvider.add({ token: SceneToken.OPEN });
        }
      }
      return true;
    });
  }

  private onHistoryChange(event: PopStateEvent) {
    const mode = this.quiz.getState().quizOptions.mode;

    if ((!event.state || event.state.namespace != "dentolo_quiz") && mode == QuizMode.POPUP) {
      this.quiz.close();
      return;
    }

    if (event.state?.namespace == "dentolo_quiz") {
      if (this.quiz.getState().status == QuizStatus.CLOSED) {
        this.quiz.open(OpenTrigger.HISTORY_API);
      }
    }

    this.postMessageProvider.send(PostMessageEvent.CHANGE_HISTORY, { scene: event.state });
  }

  private onQuizChangeHistory({ type, scene }: any) {
    if (type == "forward") this.historyProvider.forward();
    if (type == "push") this.historyProvider.add(scene);
    if (type == "back") this.historyProvider.back();
    if (type == "replace") this.historyProvider.replace(scene);
    if (type == "close") {
      this.historyProvider.replace(null);
      this.quiz.close();
    }
  }
}